import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import kebabCase from 'lodash/kebabCase';
import sortBy from 'lodash/sortBy';
import NavItem from '../NavItem/NavItem.component'

const PoliciesNav =  React.memo(function MemoPoliciesList(){

    const data = useStaticQuery(graphql`
        query {
            allAsciidoc(filter: { frontmatter: { layout: {eq: "policy"}, skip: {ne: "all"} } }) {
                edges {
                    node {
                    frontmatter {
                        title
                        skipBefore
                        skipAfter
                        permalink
                        order
                        skip
                        topindex
                    }
                    paths {
                        from {
                        source {
                            file
                        }
                        }
                    }
                    }
                }
            }
        }
    `);


    let main;

    const items = data.allAsciidoc.edges.filter(item => {
        if(item.node.frontmatter.topindex){
            main = item
            return false
        } 
        return true
    })

    const elements = [
        {
            link: `policies/${main.node.frontmatter.permalink}/${kebabCase(main.node.frontmatter.title)}`,
            name: main.node.frontmatter.title,
            subItems: sortBy(items, 'order').map((item, indx) => {
                return { 
                    name: item.node.frontmatter.title,
                    link: `policies/${item.node.frontmatter.permalink}/${kebabCase(item.node.frontmatter.title)}`,
                    // tag: item.tag,
                    active: false,
                    order: indx + 1,
                    subItems: []
                }
            })
        }
    ]


  
    return (
      <>
        <ul className="topic-selector policies-nav">
            {elements.map(navItem => (
                <NavItem key={navItem.name} navItem={navItem} />
            ))}
        </ul>
      </>
  );
})


export default PoliciesNav;
